import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchMemberCategory, updateMemberCategory, fetchMemberTypes } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function MemberCategoryEditPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  // APIから取得した全フィールドを保持（サーバーに返す際に失わないため）
  const [original, setOriginal] = useState(null);
  const [memberTypeName, setMemberTypeName] = useState("");
  const [form, setForm] = useState({
    memberCategoryName: "",
    memberCategoryDescription: "",
  });

  const loadData = useCallback(async () => {
    try {
      const [d, types] = await Promise.all([
        fetchMemberCategory(categoryId),
        fetchMemberTypes(businessDomainId),
      ]);
      setOriginal(d);
      setForm({
        memberCategoryName: d.memberCategoryName || "",
        memberCategoryDescription: d.memberCategoryDescription || "",
      });
      const found = (Array.isArray(types) ? types : []).find(
        (mt) => mt.memberTypeId === d.memberTypeId
      );
      setMemberTypeName(found?.memberTypeName || "");
    } catch (e) { notify.apiError(e); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, businessDomainId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!original) return;
    try {
      await updateMemberCategory(categoryId, {
        ...original,
        memberCategoryName: form.memberCategoryName,
        memberCategoryDescription: form.memberCategoryDescription || null,
      });
      notify.success(t("message.update.success"));
      navigate(`/strategy/${businessDomainId}/member-categories/${categoryId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("memberCategory.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* メンバータイプ（編集不可・表示のみ） */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth disabled
              label={t("memberCategory.memberType")}
              value={memberTypeName}
            />
          </Grid>

          {/* メンバーカテゴリ名 */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth required
              label={t("memberCategory.name")}
              name="memberCategoryName"
              value={form.memberCategoryName}
              onChange={handleChange}
            />
          </Grid>

          {/* 説明 */}
          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("common.description")}
              name="memberCategoryDescription"
              value={form.memberCategoryDescription}
              onChange={handleChange}
            />
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/member-categories/${categoryId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
